import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Input,
	InputNumber,
	Button,
	Upload,
	Checkbox,
	Table,
	Image,
	Select,
	Modal,
	Divider,
	Steps,
	Radio,
	Space,
	Result,
	Popconfirm,
	Tooltip,
	Affix,
} from 'antd'
import $ from 'jquery';
import OrderCategory from '@/components/OrderCategory';
import OrderQuantity from '@/components/OrderQuantity';
import OrderAddress from '@/components/OrderAddress';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	parseTime,
	formatTime,
	httpPost
} from '@/utils/Tools';

const {Column} = Table;
const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'userInfo':{},
			'addOrderNotice':[],

			'selectedRowKeys':[],
			'selectedImageList':[],
			'orderCurrent':0,
			'orderInfo':{
				'order_type':0,
				'order_amount':0,
				'price_rate_amount':0,
				'addon_price':0,
				'addon_price_amount':0,
				'coupon_amount':0,
				'total_amount':null,
				
				'shipping_method':10,
				/*
				"order_id": "21",
				"order_sn": "202205240346244729",
				"user_id": "1",
				"company_id": "1",
				"buyer_id": "1",
				"goods_amount": "1350.00",
				"shipping_fee": "0.00",
				"order_amount": "1350.00",
				"order_status": "0",
				"add_time": "1653335184",
				"finish_time": "0",
				"update_time": "0",
				"remark": ""
				*/
			},
			
			'couponList':[],
			'selectedCouponIndex':-1,
			'deliveryList':[],
			'selectedDeliveryIndex':-1,
			
			'typeList':[[],[]],
			'showCategoryDialog':false,
			'showQuantityDialog':false,
			
			'userRankList':[],
			'methodList':{},
		};
	}
	
	componentDidMount()
	{
	}
	
	componentWillUnmount()
	{
		if(this.loop)
			window.clearInterval(this.loop);
	}
	
	init({
		imageList,
		orderType
	})
	{
		let userInfo = CommonValue.get('user_info');
		this.setState({
			'userInfo':userInfo,
		});
		if(!orderType)
			orderType = 0;
		this.state.orderInfo['order_type'] = orderType;
		
		
		imageList.forEach((row,index)=>{
			row.key = index;
		});
		
		this.setState({
			'selectedImageList':imageList,
		});
		this.getTypeList();
		this.getCouponList();
		this.getDeliveryList();
		this.getMethodList();
		this.getOrderNotice();
		
		if(+userInfo['rank_show'])
			this.getUserRankList();
	}
	
	getTypeList()
	{
		let url = pcUrl('image','typeList');
		httpPost(url)
			.then(data=>{
				data['type_list'][0] = data['type_list'][0].filter(str=>str != 'png');
				this.setState({
					//'typeList':data['type_list'][0].concat(data['type_list'][1]),
					'typeList':data['type_list'],
					'colorTypeList':data['color_type_list'],
				});
			});
	}
	
	getMethodList()
	{
		let url = pcUrl('order','methodList');
		httpPost(url)
			.then(data=>{
				//去掉未知选项
				delete(data[0]);
				
				this.setState({
					'methodList':data,
				});
			});
	}
	
	//获取可用的优惠券列表
	getCouponList()
	{
		let url = pcUrl('coupon','index');
		let param = {
			'real_coupon_status':1,
		};
		param['page_size'] = 0;
		
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'couponList':data.list
				});
			});
	}
	
	//获取交付时间列表
	getDeliveryList()
	{
		let url = pcUrl('delivery','index');
		let param = {
			'order_type':this.state.orderInfo['order_type'],
		};
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'deliveryList':data,
					'selectedDeliveryIndex':data.findIndex(row=>row.enabled),
				});
			});
	}

	//获取用户等级列表
	getUserRankList()
	{
		let url = pcUrl('user','rankList');
		httpPost(url)
			.then(data=>{
				//隐藏头部和尾部会员信息
				//data.shift();
				//data.pop();
				data = data.filter(row=>+row['is_show']);
				//隐藏自己隶属的会员
				//data = data.filter((row)=>row['rank_id']!=this.state.userInfo['rank_id']);
				
				this.setState({
					'userRankList':data,
				});
			});
	}

	getOrderNotice()
	{
		let key = 'add_order_notice';
		let orderType = this.state.orderInfo['order_type'];
		if(orderType != 0)
			key += '_'+orderType;
		
		let url = pcUrl('index','configVal');
		let param = {
			'key':key,
		};
		httpPost(url,param)
			.then(data=>{
				if(data.indexOf("\r\n") != -1)
					data = data.split("\r\n");
				else
					data = data.split("\n");

				this.setState({
					'addOrderNotice':data,
				});
			});
	}
	
	submitOrder()
	{
		let selectedImageList = this.state.selectedImageList;
		//检查规格是否选择
		let errorIndex = -1;
		selectedImageList.some((row,index)=>{
			if(!row['categories'][0].length)
			{
				errorIndex = index;
				return true;
			}
		});
		if(errorIndex != -1)
		{
			message('请为第'+(errorIndex+1)+'行图片选择材料');
			return false;
		}
		
		let addressId = this.orderAddress.getAddressId();
		
		let url = pcUrl('order','add');
		/*
		let categoriesList = [];
		selectedImageList.forEach((row,index)=>{
			let categories = JSON.parse(JSON.stringify(row['categories']));
			categories[0] = categories[0].join(',');
			categories[1] = categories[1].map(row=>row.name+':'+row.value);
			categories = categories.join('|');
			categoriesList.push(categories);
		});
		*/
		if(this.state.selectedDeliveryIndex == -1)
		{
			message('请选择交付方式');
			return false;
		}
		
		let param = {
			'address_id':addressId,
			'shipping_method':this.state.orderInfo['shipping_method'],
			'order_type':this.state.orderInfo['order_type'],
			'image_ids':selectedImageList.map(row=>row['image_id']).join(','),
			'quantity_list':selectedImageList.map(row=>row['quantity']).join(','),
			'categories_list':selectedImageList.map(row=>{ let categories = JSON.parse(JSON.stringify(row['categories'])); categories[1] = categories[1].map(row1=>row1.name+':'+row1.value); return categories; }),
			'back_path_list':selectedImageList.map(row=>(row['back_path'].length ? row['back_path'][0]['url']:'')).join(','),
			'spec_path_list':selectedImageList.map(row=>(row['spec_path'].length ? row['spec_path'][0]['url']:'')).join(','),
			'remark_list':selectedImageList.map(row=>row['remark']).join(','),
		};
		if(this.state.selectedCouponIndex != -1)
		{
			param['coupon_sn'] = this.state.couponList[this.state.selectedCouponIndex]['coupon_sn'];
		}
		if(this.state.selectedDeliveryIndex != -1)
		{
			param['delivery_id'] = this.state.deliveryList[this.state.selectedDeliveryIndex]['delivery_id'];
		}
		
		httpPost(url,param)
			.then((data)=>{
				this.props.changeCart([]);
				//公司管理者，进入下一步
				if(+this.state.userInfo['is_manager'])
				{
					let orderInfo = data;
					/*
					let imageList = this.state.imageList;
					imageList.forEach(row=>row.isChecked = false);
					*/
					
					this.setState({
						'orderInfo':orderInfo,
						'orderCurrent':1,
						//'imageList':imageList,
					},()=>{
						/*
						this.payForm.setFieldsValue({
							//'method':'alipay'
							'method':'allinpay'
						});
						*/
						this.changeMethod('allinpay');
					});
				}
				else
				{
					message('订单添加成功，您可以进入订单管理页面查看详情','success',1)
						.then(()=>{
							window.location.href = ngUrl('user','order');
						});
				}
			});
	}
	
	changeMethod(method)
	{
		if(method == 'wechatpay')
		{
			this.payForm.validateFields(['method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											//this.props.history.push('/user/success?out_trade_no='+paySn);
											window.location.href = '#/user/success?out_trade_no='+paySn;
										}
									});
							},2000);
						});
					
					this.payForm && this.payForm.setFieldsValue({'method':method});
				});
		}
		else if(method == 'allinpay')
		{
			this.payForm.validateFields(['method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											//this.props.history.push('/user/success?out_trade_no='+paySn);
											window.location.href = '#/user/success?out_trade_no='+paySn;
										}
									});
							},2000);
						});
					
					this.payForm && this.payForm.setFieldsValue({'method':method});
				});
		}
		else
		{
			if(this.loop)
				window.clearInterval(this.loop);
		
			this.payForm && this.payForm.setFieldsValue({'method':method});
		}
	}
	submit(info)
	{
		this._submit(info)
			.then(data=>{
				//支付宝充值，直接进行跳转
				if(info.method == 'alipay')
				{
					document.write(data);
				}
				//余额支付，进入成功页
				else if(info.method == 'moneypay')
				{
					let paySn = data;
					//this.props.history.push('/user/success?out_trade_no='+paySn);
					window.location.href = '#/user/success?out_trade_no='+paySn;
				}
			});
	}
	
	_submit(info)
	{
		let url = pcUrl('order','charge');
		let param = {
			'order_id':this.state.orderInfo['order_id'],
			'method': ['alipay','wechatpay','moneypay','allinpay'].indexOf(info.method),
		};
		
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					resolve(data);
				})
				.catch(e=>reject(e));
		});
	}
	
	chooseCategory(indexs)
	{
		if(!Array.isArray(indexs)) indexs = [indexs];
		
		let info = this.state.selectedImageList[indexs[0]];
		this.state.orderImageIndexs = indexs;
		this.setState({
			'showCategoryDialog':true,
		},()=>{
			let data = {
				//'quantity':info.quantity,
			};
			if(info['categories'][0].length)
				data.categoryIds = JSON.parse(JSON.stringify(info['categories'][0]));
			
			this.orderCategory.init({
				'categoryIds':data,
			});
		});
	}
	
	batchChooseCategory()
	{
		let selection = this.state.selectedRowKeys;
		if(!selection.length)
		{
			message('请选择要操作的图片');
			return;
		}
		this.chooseCategory(selection);
	}

	batchSetQuantity()
	{
		let selection = this.state.selectedRowKeys;
		if(!selection.length)
		{
			message('请选择要操作的图片');
			return;
		}
		
		let indexs = selection;
		this.state.orderImageIndexs = indexs;
		let info = this.state.selectedImageList[indexs[0]];
		let data = {
			'quantity':info.quantity,
		};
		
		this.setState({
			'showQuantityDialog':true,
			},()=>{
				this.orderQuantity.init(data);
			});
	}
	
	submitCategory()
	{
		//计算图片价格
		let result = this.orderCategory.getCategoryResult();
		if(!result.flag)
		{
			message(result.message);
			return false;
		}
		
		let indexs = this.state.orderImageIndexs;
		let selectedImageList = this.state.selectedImageList;
		indexs.forEach(index=>{
			selectedImageList[index]['categories'] = result.data;
			//selectedImageList[index]['quantity'] = result.quantity;
		});
		
		this.calcPrice();
		this.setState({
			'selectedImageList':selectedImageList,
			'showCategoryDialog':false,
			'selectedRowKeys':[],
		});
	}
	submitQuantity()
	{
		//计算图片价格
		let quantity = this.orderQuantity.getResult();
		
		let indexs = this.state.orderImageIndexs;
		let selectedImageList = this.state.selectedImageList;
		indexs.forEach(index=>{
			selectedImageList[index]['quantity'] = quantity;
		});
		
		this.calcPrice();
		this.setState({
			'selectedImageList':selectedImageList,
			'showQuantityDialog':false,
			'selectedRowKeys':[],
		});
	}
	
	quantityChange(type,index)
	{
		let selectedImageList = this.state.selectedImageList;
		let row = selectedImageList[index];
		
		if('-' == type)
		{
			if(row.quantity == 1) return false;
			row.quantity--;
		}
		else if('+' == type)
		{
			row.quantity++;
		}
		this.setState({'selectedImageList':this.state.selectedImageList});
		this.calcPrice();
	}
	
	//计算订单价格
	calcPrice(rankId)
	{
		let selectedImageList = this.state.selectedImageList;
		let imageIds = [];
		let categoryIdsList = [];
		let quantityList = [];
		selectedImageList.forEach(row=>{
			if(row['categories'][0].length)
			{
				imageIds.push(row['image_id']);
				categoryIdsList.push(row['categories'][0]);
				quantityList.push(row.quantity);
			}
		});
		if(!imageIds.length)
		{
			let orderInfo = this.state.orderInfo;
			orderInfo = {
				'order_amount':0,
				'shipping_method':10,
			};
			let userRankList = this.state.userRankList;
			userRankList.forEach(row=>{
				row['order_amount'] = 0;
				row['total_amount'] = null;
			});
			
			//还原价格
			this.setState({
				'orderInfo':orderInfo,
				'userRankList':userRankList,
			});
			return false;
		}
		
		let url = pcUrl('order','calcPrice');
		let param = {
			'image_ids':imageIds.join(','),
			'category_ids_list':categoryIdsList.map(row=>row.join(',')).join('|'),
			'quantity_list':quantityList.join(','),
		};
		if(rankId)
			param['rank_id'] = rankId;
		
		httpPost(url,param)
			.then(data=>{
				if(!rankId)
				{
					let orderInfo = this.state.orderInfo;
					orderInfo['order_amount'] = data.total;
					selectedImageList.forEach((row,index)=>{
						let imageId = row['image_id'];
						if(data[imageId])
						{
							row['image_price'] = data[imageId]['image_price'];
							row['image_amount'] = data[imageId]['image_amount'];
							row['pay_amount'] = data[imageId]['pay_amount'];
						}
					});
					this.setState({
						'orderInfo':orderInfo,
						'selectedImageList':selectedImageList,
						//取消优惠券的使用
						'selectedCouponIndex':-1,
					},()=>{
						this._calcTotalPrice();
					});
				}
				else
				{
					let rankInfo = this.state.userRankList.find(row=>row['rank_id'] == rankId);
					rankInfo['order_amount'] = data.total;
					this.setState({
						'userRankList':this.state.userRankList,
					},()=>{
						this._calcTotalPrice(rankId);
					});
				}
			});
		
		if(!rankId && this.state.userRankList.length)
		{
			this.state.userRankList.forEach(row=>{
				this.calcPrice(row['rank_id']);
			});
		}
	}
	
	calcTotalPrice(rankId)
	{
		this._calcTotalPrice(rankId);
			
		if(
			!rankId &&
			this.state.userRankList.length
		)
		{
			this.state.userRankList.forEach(row=>{
				this._calcTotalPrice(row['rank_id']);
			});
		}
	}
	
	_calcTotalPrice(rankId)
	{
		if(!this.state.orderInfo['order_amount']) return false;
		if(this.state.selectedDeliveryIndex == -1) return false;
		if(+rankId > +this.state.userInfo['rank_id']) return false;
		
		let url = pcUrl('order','calcTotalPrice');
		let param = {};
		if(!rankId)
		{
			param['order_amount'] = this.state.orderInfo['order_amount'];
		}
		else
		{
			param['order_amount'] = this.state.userRankList.find(row=>row['rank_id'] == rankId)['order_amount'];
			param['rank_id'] = rankId;
			if(!param['order_amount']) return false;
		}
		
		if(this.state.selectedDeliveryIndex != -1)
			param['delivery_id'] = this.state.deliveryList[this.state.selectedDeliveryIndex]['delivery_id'];
		if(this.state.selectedCouponIndex != -1)
			param['coupon_sn'] = this.state.couponList[this.state.selectedCouponIndex]['coupon_sn'];
		
		httpPost(url,param)
			.then(data=>{
				if(!rankId)
				{
					let orderInfo = this.state.orderInfo;
					for(let key in data)
						orderInfo[key] = data[key];
					
					this.setState({
						'orderInfo':orderInfo,
					});
				}
				else
				{
					let rankInfo = this.state.userRankList.find(row=>row['rank_id'] == rankId);
					for(let key in data)
						rankInfo[key] = data[key];
						
					this.setState({
						'userRankList':this.state.userRankList,
					});
				}
			});
	}
	
	//删除选中的图片
	deleteSelectedImage(index)
	{
		let selectedImageList = this.state.selectedImageList;
		/*
		if(selectedImageList.length == 1)
		{
			message('不能删除最后的图片');
			return false;
		}
		*/
		
		selectedImageList.splice(index,1);
		this.props.changeCart(selectedImageList.map(row=>row['image_id']));
		this.setState({
			'selectedImageList':[...selectedImageList],
		},()=>{
			this.calcPrice();
		});
	}

	//批量删除图片
	batchDeleteImage()
	{
		let selection = this.state.selectedRowKeys;
		if(!selection.length)
		{
			message('请选择要删除的图片');
			return;
		}
		confirm('确认要删除选中的图片吗?')
			.then(()=>{
				let selectedImageList = this.state.selectedImageList;
				selectedImageList = selectedImageList.filter((row,index)=>!selection.includes(index));
				this.props.changeCart(selectedImageList.map(row=>row['image_id']));
				this.setState({
					'selectedImageList':[...selectedImageList],
					'selectedRowKeys':[],
				},()=>{
					this.calcPrice();
				});
			});
	}
	
	handleRemoveImage(file,index,nameKey)
	{
		return new Promise((resolve,reject)=>{
			confirm('确认要删除该文件吗?')
				.then(()=>{
					if('back_path' == nameKey)
					{
						let url = pcUrl('image','deleteFile');
						let param = {
							'file_name':file.thumbUrl,
						};
						httpPost(url,param)
							.then(()=>{
								//删除oss文件
								let temp = file.thumbUrl.split('/');
								let fileName = temp.pop();
								fileName = fileName.split('.');
								//fileName.pop();
								fileName.pop();
								fileName = fileName.join('.');
								
								let date = temp.pop();
								let preg = /(\d{4})(\d{2})(\d{2})/;
								preg.test(date);
								date = RegExp.$1 +'_'+ RegExp.$2 +'_'+ RegExp.$3;
								//date = formatTime('Y_m_d',(new Date(date)).getTime()/1000);
								
								let ossFileName = 'preview/'+date+'/'+fileName;
								param['file_name'] = ossFileName;
								httpPost(url,param)
									.then(()=>{
										let selectedImageList = this.state.selectedImageList;
										selectedImageList[index][nameKey] = [];
										this.setState({
											'selectedImageList':selectedImageList,
										});
										resolve();
									});
							});
					}
					else if('spec_path' == nameKey)
					{
						let url = pcUrl('image','deleteFile');
						let param = {
							'file_name':file.thumbUrl,
						};
						httpPost(url,param)
							.then(()=>{
								let selectedImageList = this.state.selectedImageList;
								selectedImageList[index][nameKey] = [];
								this.setState({
									'selectedImageList':selectedImageList,
								});
								resolve();
							});
					}
				})
				.catch(()=>{
					reject();
				});
		});
	}
	
	handlePreviewImage(file)
	{
		this.setState({
			'preview':{
				'visible':true,
				'src':file.url,
				//'src':file.thumburl,
			},
		});
	}
	
	handleUpload({action,data,file,method},index,keyName)
	{
		let selectedImageList = this.state.selectedImageList;
		selectedImageList[index][keyName][0] = file;
		file.status = 'uploading';
		
		this.setState({
			'selectedImageList':selectedImageList,
		});
		
		let url = pcUrl('image','preUploadFile');
		let param = data;
		data['file_name'] = file.name;
		
		httpPost(url,param)
			.then(data=>{
				//正式上传
				url = data.host;
				let param = new FormData();
				param.append('name',file.name);
				param.append('key',data['file_name']);
				param.append('policy',data.policy);
				param.append('OSSAccessKeyId',data.accessid);
				param.append('callback',data.callback);
				param.append('signature',data.signature);
				param.append('file',file);
				param.append('success_action_status',200);
				httpPost(url,param,{
					'onUploadProgress':(event)=>{
						file.percent = Math.round(event.loaded*100 / event.total);
						this.setState({
							'selectedImageList':selectedImageList,
						});
					}
				})
					.then(data=>{
						//图片上传完毕，进行处理
						url = pcUrl('image','postUploadFile');
						param = {
							'file_name':data,
						};
						if(keyName == 'back_path')
						{
							//param['is_cmyk'] = 1;
							param['file_type'] = 'back_image';
						}
						else if(keyName == 'spec_path')
						{
							param['file_type'] = 'spec_image';
						}
						
						httpPost(url,param,{'rawResponse':1})
							.then(data=>{
								//错误处理
								if(data.code != 0)
								{
									message(data.message);
									//清空文件
									selectedImageList[index][keyName] = [];
									this.setState({
										'selectedImageList':selectedImageList,
									});
									return;
								}
								if('back_path' == keyName)
								{
									data = data.data;
									let backUrl = data;
									file.status = 'done';
									file.thumbUrl = require('@/assets/images/generating_thumb.jpg');
									//file.url = data.replace('thumb.','');
									file.url = require('@/assets/images/generating_thumb.jpg');
									
									this.setState({
										'selectedImageList':selectedImageList,
									});
									//循环监测缩略图是否生成
									file.loop = window.setInterval(()=>{
										let testImage = new window.Image();
										testImage.onload = ()=>{
											file.thumbUrl = backUrl;
											file.url = backUrl;
											window.clearInterval(file.loop);
											this.setState({
												'selectedImageList':selectedImageList,
											});
										};
										/*
										testImage.onerror = (error)=>{
											console.log(error);
										};
										*/
										testImage.src = backUrl;
									},2000);
								}
								else
								{
									data = data.data;
									file.status = 'done';
									file.thumbUrl = data;
									//file.url = data.replace('thumb.','');
									file.url = data;
									
									this.setState({
										'selectedImageList':selectedImageList,
									});
								}
							});
					});
			});
	}
	
	handleUploadImageChange(data,index,keyName)
	{
		return;
		if(data.fileList.length)
		{
			data.fileList.forEach((row,index)=>{
				if(row.response)
				{
					let response = row.response;
					if(response.code != 0)
					{
						message(response.message);
						return;
					}
					
					data.fileList[index] = {
						'uid':index+1,
						'name':row.name,
						'status':'done',
						'thumbUrl':response.data,
						'url':response.data.replace('thumb.',''),
					};
				}
			});
			data.fileList = data.fileList.filter(row=>{
				if(row.response && row.response.code != 0)
					return false;
				else
					return true;
			});
		}
		let list = this.state.selectedImageList;
		list[index][keyName] = data.fileList;
		this.setState({
			//'backPathList':data.fileList,
			'selectedImageList':list,
		});
		
		/*
		this.mainForm.setFieldsValue({
			'business_license':data.fileList,
		});
		*/
	}
	
	//返回步骤1
	backOrder()
	{
		confirm('返回步骤1，会重新生成新的订单，确认要返回吗?')
			.then(()=>{
				this.setState({
					'orderCurrent':0,
				});
			});
	}
	
	render()
	{
		return (
			<div className="bg-gray">
				<div className="body" style={{'minWidth':'1200px','maxWidth':'2500px','width':'95%'}}>
					<div>
						<div className="height-20"></div>
						<div className="padding-20">
							<Steps current={this.state.orderCurrent} status={this.state.orderCurrent == 2 ?'finish':'process'}>
								<Steps.Step title="生成订单" />
								<Steps.Step title="支付订单" />
								<Steps.Step title="交易成功" />
							</Steps>
						</div>
						<div className="height-20"></div>
						{/*
						<div>
							<Upload
								action={pcUrl('index','upload')}
								showUploadList={true}
								onRemove={file=>this.handleRemoveImage(file)}
								onChange={data=>this.handleUploadImageChange(data)}
								onPreview={file=>this.handlePreviewImage(file)}
								fileList={this.state.backPathList}
								data={{'thumb_size':'500,500'}}
								listType="picture-card">
								<div>
									<span style={{fontSize:'20px'}}>+</span>
									<br/>
									选择图片
								</div>
							</Upload>
						</div>
						*/}
						{this.state.orderCurrent == 0 && (
							<>
								<OrderAddress ref={e=>this.orderAddress  = e} />
								<div className="height-30"></div>
								<Divider>所选图片</Divider>
								<Affix offsetTop={10}>
									<div className="text-right" style={{'marginBottom':'1em'}}>
										<Button type="primary" onClick={()=>this.batchChooseCategory()}>设置材质</Button>
											&nbsp;&nbsp;
										<Button type="primary" onClick={()=>this.batchSetQuantity()}>设置数量</Button>
											&nbsp;&nbsp;
											<Button type="primary" danger onClick={()=>this.batchDeleteImage()}>批量删除</Button>
									</div>
								</Affix>
								<Table
									rowSelection={{
										'selectedRowKeys':this.state.selectedRowKeys,
										'onChange':(selectedRowKeys, selectedRows)=>{this.setState({selectedRowKeys})},
									}}
									pagination={false} dataSource={this.state.selectedImageList} scroll={{'x':true }}>
									<Column title="正面" ellipsis={{showTitle:true}} width={120} fixed width={100} dataIndex="thumb_name" render={(text,row,index)=>(
										<>
										<div className="image-box">
											<a href="javascript:;" onClick={()=>this.setState({'preview':{'visible':true,'src':row['image_path']['image_name']}})}>
												<img src={row['image_path']['thumb_name']} />
											</a>
										</div>
										{/*
										<div style={{ width:'120px', wordWrap: 'break-word', wordBreak: 'break-word' }}>
											<Image src={row['image_path']['thumb_name']} width={100} height={100} />
											<br />
											<Tooltip placement="topLeft" title={row['image_name']}>
												{row['image_name']}
											</Tooltip>
										</div>
										*/}
										</>
									)} />
									<Column title="文件名" width={120} fixed width={100} dataIndex="image_name" />
									<Column title="反面" ellipsis={true} width={100} dataIndex="back_path" render={(text,row,index)=>(
										<Upload
											action={pcUrl('index','upload')}
											showUploadList={true}
											accept={this.state.typeList[0].map(str=>'.'+str).join(',')}
											customRequest={data=>this.handleUpload(data,index,'back_path')}
											onRemove={file=>this.handleRemoveImage(file,index,'back_path')}
											onChange={data=>this.handleUploadImageChange(data,index,'back_path')}
											onPreview={file=>this.handlePreviewImage(file)}
											fileList={row['back_path']}
											data={{}}
											listType="picture-card">
											{row['back_path'].length == 0 ? (
												<div>
													<span style={{fontSize:'20px'}}>+</span>
													<br/>
													选择图片
												</div>
											):''}
										</Upload>
									)} />
									<Column title="异形" ellipsis={true} width={100} dataIndex="spec_path" render={(text,row,index)=>(
										<div style={{'width':'100px',
												'overflow': 'hidden',
												'white-space': 'nowrap',
												'text-overflow':'ellipsis'
											}}>
											<Upload
												action={pcUrl('index','uploadFile')}
												showUploadList={true}
												accept={this.state.typeList[0].concat(this.state.typeList[1]).map(str=>'.'+str).join(',')}
												customRequest={data=>this.handleUpload(data,index,'spec_path')}
												onRemove={file=>this.handleRemoveImage(file,index,'spec_path')}
												onChange={data=>this.handleUploadImageChange(data,index,'spec_path')}
												fileList={row['spec_path']}>
												{row['spec_path'].length == 0 ? (
													<Button size="small">
														<span>+</span>
														<span style={{'fontSize':'12px'}}> 选择文件 </span>
													</Button>
												):''}
											</Upload>
										</div>
									)} />
									<Column title="材料" ellipsis={true} width={200} dataIndex="" render={(text,row,index)=>(
										<>
											{row['categories'][0].length ? (
											<span>{row['categories'][1].map(row=>(
												<>
													<span>
														{row.name+':'+row.value}
													</span>
													<br />
												</>
											))}</span>
											):''}
											<a href="javascript:;" className="text-blue" onClick={()=>this.chooseCategory(index)}>选择材料</a>
										</>
									)} />
									<Column title="图片尺寸" ellipsis={true} width={200} dataIndex="" render={(text,row,index)=> row['image_dimension'].split('*').map(row=>row+'CM').join('*')} />
									<Column title="单价" ellipsis={true} width={50} dataIndex="image_price" render={(text,row,index)=> row['image_price'] != '' ? ('￥'+row['image_price']):''} />
									<Column title="数量" ellipsis={true} width={50} dataIndex="quantity" render={(text,row,index)=>(
										<Input.Group>
											<Space size={2}>
												<Button onClick={()=>this.quantityChange('-',index)}>-</Button>
												<Input value={row.quantity} style={{'width':'50px','textAlign':'center'}} onChange={event=>{ let val = event.target.value; if(val!=+val || val <= 0) val = 1; row.quantity = val; this.setState({'selectedImageList':this.state.selectedImageList});this.calcPrice();}} />
												<Button onClick={()=>this.quantityChange('+',index)}>+</Button>
											</Space>
										</Input.Group>
									)}/>
									{/*
										<Column title="原价" ellipsis={true} width={100} dataIndex="image_amount" render={(text,row,index)=>row['image_amount'] != '' ? ("￥"+row['image_amount']):''} />
									*/}
									<Column title="总价" ellipsis={true} width={110} dataIndex="pay_amount" render={(text,row,index)=>row['pay_amount'] != '' ? ("￥"+row['pay_amount']):''} />
									<Column title="备注" ellipsis={true} width={150} dataIndex="remark" render={(text,row,index)=>(
										<Input value={row.remark} style={{'width':'150px'}} placeholder="请填写备注" onChange={e=>{ row.remark = e.target.value; this.setState({'selectedImageList':this.state.selectedImageList});}} />
									)} />
									<Column title="操作" fixed="right" ellipsis={true} width={100} key="operate" render={(text,row,index)=>(
										<>
										{1 || this.state.selectedImageList.length >1? (
											<Popconfirm
												title="确认删除该记录吗?"
												onConfirm={()=>this.deleteSelectedImage(index)}
												onCancel={()=>{}}
												>
												<a href="javascript:;" className="text-red">删除</a>
											</Popconfirm>
										):''}
										</>
									)} />
								</Table>
								<div className="height-10"></div>
								<div className="pay-foot">
									{this.state.addOrderNotice.length >0 && (
										<div style={{'background-color':'#FEFEFE','color':'#888','padding':'1em 1em 1em 2em','marginBottom':'1em'}}>
											{this.state.addOrderNotice.map(val=>(
											<>
												{val}
												&nbsp;&nbsp;
											</>
											))}
										</div>
									)}
									<div style={{'padding-left':'2em'}}>
										<div style={{'margin-bottom':'1em'}}>
											配送方式：
											&nbsp;
											<Radio.Group value={this.state.orderInfo['shipping_method']} onChange={e=>{let val = e.target.value;let orderInfo = this.state.orderInfo;orderInfo['shipping_method']=val;this.setState({'orderInfo':orderInfo});}}>
												{Object.keys(this.state.methodList).map(key=>(
													<Radio value={+key}>{this.state.methodList[key]}</Radio>
												))}
											</Radio.Group>
										</div>
										<div style={{'margin-bottom':'1em'}}>
											交付方式：
											&nbsp;
											<Radio.Group value={this.state.selectedDeliveryIndex} onChange={e=>{let index = e.target.value;this.setState({'selectedDeliveryIndex':index},()=>{this.calcTotalPrice();});}}>
												{this.state.deliveryList.map((row,index)=>(
													<Radio disabled={!row.enabled} value={index}>{row['delivery_name']}</Radio>
												))}
											</Radio.Group>
										</div>
										<div style={{'margin-bottom':'1em'}}>
											　优惠券：
											&nbsp;
											{this.state.couponList.length > 0 ? (
												<Select style={{'width':'10em','text-align':'center'}} placeholder="选择优惠券" value={this.state.selectedCouponIndex} onChange={index=>{if(index == undefined) index = -1;this.setState({'selectedCouponIndex':index},()=>{this.calcTotalPrice();});}}>
													<Select.Option value={-1}>不使用优惠券</Select.Option>
													{this.state.couponList.map((row,index)=>(
														<Select.Option value={index} disabled={+row['min_expense']>this.state.orderInfo['order_amount']}>满{+row['min_expense']}元减{+row['coupon_amount']}元</Select.Option>
													))}
												</Select>
											):(
												<span className="text-gray">没有可用的优惠券</span>
											)}
										</div>
										<div>
											合计金额：
											<span className="text-red" style={{'fontSize':'20px'}}>
												￥{this.state.orderInfo['total_amount'] != null ? this.state.orderInfo['total_amount']:this.state.orderInfo['order_amount']}元
											</span>
											&nbsp;&nbsp;&nbsp;
											{(this.state.orderInfo['total_amount'] || this.state.orderInfo['order_amount']) && this.state.userRankList.length>0 ? (
												<span style={{'background-color':'white','padding':'1em 1em','border-radius':'5px','display':'inline-block','color':'#999','margin-top':'1em'}}>
													{this.state.userRankList.map(row=>(
													<>
														&nbsp;
														{row['rank_name']}:
														{+row['rank_id'] <= +this.state.userInfo['rank_id'] ? (
														<>
															<span style={{'color':'#666'}}> ￥{row['total_amount'] != null ? row['total_amount']:row['order_amount']} </span>
															元
														</>
														):(
															<span style={{'color':'#666'}}> ￥??元 </span>
														)}
														&nbsp;
													</>
													))}
												</span>
											):''}
										</div>
									</div>
								</div>
							</>
						)}
						{this.state.orderCurrent == 1 && (
							<div style={{'backgroundColor':'white','padding':'0 0 1em 0'}}>
								<div className="pay-head">
									<dl>
										<dt>
											应付金额：
											<span className="text-red"> ￥{this.state.orderInfo['order_amount']} </span>
											<p>
												<a href="javascript:;" onClick={()=>this.backOrder()}>（返回上一步）</a>
											</p>
										</dt>
										<dd>
											订单编号：{this.state.orderInfo['order_sn']}
										</dd>
										<dd>
											提交时间：{parseTime(this.state.orderInfo['add_time'])}
										</dd>
									</dl>
								</div>
								<div className="height-20"></div>
								<Form
									ref={e=>this.payForm = e}
									onFinish={(data)=>this.submit(data)}
									onFinishFailed={data=>this.focusError(data)}
									labelCol={{ span:3 }}
									wrapperCol={{ span:14 }}>
									<Form.Item name="method" label="支付方式">
										<Form.Item shouldUpdate>
											{()=>(
												<>
													<div className="pay-method">
														<ul>
															{/*
																<li onClick={()=>this.changeMethod('alipay')}>
																	<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'alipay'} value="alipay"></Radio>
																	<img className="alipay-icon" src={require("@/assets/images/alipay.png")} />
																</li>
																<li onClick={()=>this.changeMethod('wechatpay')}>
																	<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'wechatpay'} value="wechatpay"></Radio>
																	<img className="wechatpay-icon" src={require("@/assets/images/wechatpay.jpg")} />
																</li>
															*/}
															<li onClick={()=>this.changeMethod('allinpay')}>
																<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'allinpay'} value="allinpay"></Radio>
																<img className="wechatpay-icon" src={require("@/assets/images/allinpay.png")} />
															</li>
															<li onClick={()=>this.changeMethod('moneypay')}>
																<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'moneypay'} value="moneypay"></Radio>
																<img className="wechatpay-icon" src={require("@/assets/images/money_pay.jpg")} />
															</li>
														</ul>
													</div>
													{this.payForm && this.payForm.getFieldValue('method') == 'wechatpay' && (
														<div className="pay-area">
															<div className="pay-area-left">
																<div className="pay-qr">
																	{/*
																	<img src={require("@/assets/images/wechat_qr.jpg")} />
																	*/}
																	<img src={this.state.wechatpay_qrcode} />
																</div>
																<div className="pay-attention">
																	<dl>
																		<dd className="float-left">
																			<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
																		</dd>
																		<dt>
																			请使用微信扫一扫
																			<br/>
																			扫描二维码以完成支付
																		</dt>
																	</dl>
																</div>
															</div>
															<div className="pay-area-right">
																<img src={require("@/assets/images/wechatpay_exp.jpg")} />
															</div>
														</div>
													)}
													{this.payForm && this.payForm.getFieldValue('method') == 'allinpay' && (
														<div className="pay-area">
															<div className="pay-area-left">
																<div className="pay-qr">
																	{/*
																	<img src={require("@/assets/images/wechat_qr.jpg")} />
																	*/}
																	<img src={this.state.wechatpay_qrcode} />
																</div>
																<div className="pay-attention">
																	<dl>
																		<dd className="float-left">
																			<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
																		</dd>
																		<dt>
																			请使用微信或支付宝扫一扫
																			<br/>
																			扫描二维码以完成支付
																		</dt>
																	</dl>
																</div>
															</div>
															{/*
																<div className="pay-area-right">
																	<img src={require("@/assets/images/wechatpay_exp.jpg")} />
																</div>
															*/}
														</div>
													)}
												</>
											)}
										</Form.Item>
									</Form.Item>
									{/*
										<Form.Item shouldUpdate label="营业执照">
											{()=>JSON.stringify(this.payForm && this.payForm.getFieldsValue())}
										</Form.Item>
									*/}
									<Form.Item shouldUpdate wrapperCol={{ offset:3 }}>
									{()=>this.payForm && !['wechatpay','allinpay'].includes(this.payForm.getFieldValue('method')) && (
										<Button block type="primary" htmlType="submit" style={{'width':'18em','height':'36px'}}>确认</Button>
									)}
									</Form.Item>
								</Form>
							</div>
						)}
						{this.state.orderCurrent == 2 && (
							<>
								<Result
									status="success"
									title="您已经成功支付订单"
									subTitle={(
										<>
										<div style={{'margin-top':'.5em'}}>
												订单编号: 2017182818828182881
											</div>
											<div>
												我们马上为您的订单进行生产处理，您可以在"我的订单"中查看该订单的最新进度.
											</div>
										</>
									)}
									extra={[
										<Button type="primary" key="console">
											我的订单
										</Button>,
										<Button key="console">
											继续下单
										</Button>,
									]}
								/>
							</>
						)}
						<div className="text-center" style={{'padding':'30px 0 20px 0'}}>
							{+this.state.userInfo['is_manager']?
								this.state.orderCurrent == 0 ? (
								<>
									<Button onClick={()=>this.props.back && this.props.back()}>返回</Button>
									&nbsp;&nbsp;&nbsp;
									{this.state.selectedImageList.length ? (
										<Button type="primary" onClick={()=>this.submitOrder()}>下一步</Button>
									):''}
								</>
								):''
							:(
								<>
									<Button onClick={()=>this.props.back && this.props.back()}>返回</Button>
									&nbsp;&nbsp;&nbsp;
									<Button type="primary" onClick={()=>this.submitOrder()}>确认</Button>
								</>
							)}
						</div>
						
						<Image preview={{...this.state.preview,'onVisibleChange':val=>{let preview = this.state.preview; preview.visible = val; this.setState({'preview':{...preview}});}}} />
						<Modal
							title="选择材质"
							width={1000}
							visible={this.state.showCategoryDialog}
							onOk={()=>this.submitCategory()}
							onCancel={()=>this.setState({'showCategoryDialog':false})}
							>
							<OrderCategory orderType={this.state.orderInfo['order_type']} ref={e=>this.orderCategory = e} />
						</Modal>
						<Modal
							title="设置数量"
							width={500}
							visible={this.state.showQuantityDialog}
							onOk={()=>this.submitQuantity()}
							onCancel={()=>this.setState({'showQuantityDialog':false})}
							>
							<OrderQuantity ref={e=>this.orderQuantity = e} />
						</Modal>
					</div>
				</div>
			</div>
		);
	}
}

